import { render, staticRenderFns } from "./BoxValoresPagamentos.vue?vue&type=template&id=9fc54102&scoped=true&lang=html&"
import script from "./BoxValoresPagamentos.vue?vue&type=script&lang=js&"
export * from "./BoxValoresPagamentos.vue?vue&type=script&lang=js&"
import style0 from "./BoxValoresPagamentos.vue?vue&type=style&index=0&id=9fc54102&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc54102",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/pagamento/BoxValoresPagamentos.vue
// module id = 1261
// module chunks = 28